<template>
  <div>
    <BannerIMG :bannerArray="banners"/>  
    <div id="lightBG" class="lightBG">
        <div id="pageCard" class="contentBox mainContent">
          <div v-for="(item,index) in categoryList" :key="item.id" class="flexCenter">
            <div class="item">
              <div class="itemRow"></div>
              <div>
                <div class="steps" style="height: 300px;">
                  <el-steps direction="vertical" :active="index">
                    <el-step v-for="step in categoryList" :key="+step.id"></el-step>                    
                  </el-steps>
                </div>
              </div>
              <div class="itemTitle">
                <div class="titleLine0"></div>
                <div class="titleLine1"></div>
                <div class="titleLine2"></div>
                <div class="titleLine3"></div>
                <div class="zh">{{ item.title }}</div>
                <div class="en">{{ item.en_title }}</div>
              </div>
              <div class="itemContent">
                <div class="mainIMG">
                  <div class="img">                        
                      <img v-if="canBeShow" :ref="'a'+item.id"/>
                  </div>
                </div>
                <div class="rightContent">
                  <div class="imgList">
                    <div v-for="p in 4" :key="p" class="images">
                      <div class="img">                        
                        <img :ref="'a'+item.id+'_'+p">
                      </div>
                    </div>
                  </div>
                  <div class="buttonContent">
                    <a class="button" @click="linkTo(item)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>            
        </div>
    </div>
  </div>
</template>

<script>
import BannerIMG from '@/components/BannerIMG.vue';
  
export default {
  name: 'equipmentPage',
  components: {
    BannerIMG
  },
  watch:{
    'isProductListOK': function() {
      this.$nextTick(() => {
        this.categoryList.forEach(category => {
          let listen = setInterval(() => {
            if(this.$refs['a'+category.id] != undefined && this.productList['a'+category.id] != undefined){
              clearInterval(listen);
              if(this.$refs['a'+category.id].length > 0){
                const productData = this.productList['a'+category.id];
                // 验证产品数据是否存在
                if(productData && productData[0] && productData[0][0]){
                  this.$refs['a'+category.id][0].src = this.baseUrl+productData[0][0].cover_img;
                  //绑定点击事件
                  if (this.$refs['a'+category.id][0].parentNode) {
                    let main = this.$refs['a'+category.id][0].parentNode;
                    main.parentNode.addEventListener('click', () => {
                        let id = productData[0][0].id
                        window.open('/#/productDetail?id=' + id, '_blank');
                    });
                  }
                  //匹配'a'+category.id+'_'
                  for(let i=1;i<=4;i++){
                    let a = this.$refs['a'+category.id+'_' + i][0];
                    // 检查该索引的产品是否存在
                    if(productData[0] && productData[0][i]){
                      a.src = this.baseUrl+productData[0][i].cover_img_text;
                      //绑定点击事件
                      if (a.parentNode) {
                          a.parentNode.addEventListener('click', () => {
                              let id = productData[0][i].id
                              window.open('/#/productDetail?id=' + id, '_blank');
                          });
                      }
                    }
                  }
                }
              }              
            }
          }, 50);          
        });

        this.canBeShow = true;
      });     
    }
  },
  data() {
    return {
      baseUrl:window.config.apiUrl,
      banners:[],
      categoryList:[],
      productList:{},
      isProductListOK:false,
      canBeShow:false,
    }
  },
  methods: {
    async getBaseData() {
        try {
            this.categoryList = await this.$root.getCategoryData();  // 获取类别数据
            for (const category of this.categoryList) {
                this.productList['a' + category.id] = await this.$root.getProductListData(category.id);
            }
            this.isProductListOK = true;
            let bannerInfo = await this.$root.getBanner(3);
            this.banners = bannerInfo.data;


            //console.log(this.productList,'productList');
            

            // 修正页面高度
            this.fixLightBGHeight("pageCard", "lightBG");
        } catch (error) {
            this.error = '获取数据失败：' + error.message;
        }
        this.$root.loadingClose();
    },
    fixLightBGHeight(contentElementId,backgroundElementId){            
      let pageCard = document.getElementById(contentElementId);        
      let lightBG = document.getElementById(backgroundElementId);         
      let pageCardHeight = pageCard.offsetHeight;    
      lightBG.style.height = pageCardHeight + 'px'; 
      // //判断图片是否全部加载完成
      // let imgList = document.querySelectorAll('.img img');
      // let imgLoadedCount = 0;      
      // imgList.forEach((img) => {
      //   if(img.src != ""){
      //       img.onload = () => {
      //         imgLoadedCount++;
      //         if (imgLoadedCount === imgList.length) {                        
      //             let pageCardHeight = pageCard.offsetHeight;    
      //             lightBG.style.height = pageCardHeight + 'px';   
      //             this.isIMGOK = true;
      //         }
      //     }; 
      //   }
      //   else{
      //     imgLoadedCount++;
      //     if (imgLoadedCount === imgList.length) {                       
      //         let pageCardHeight = pageCard.offsetHeight;    
      //         lightBG.style.height = pageCardHeight + 'px';   
      //         this.isIMGOK = true;
      //     }
      //   }
      // });
    },
    addBGClass(){
      let itemRow = document.getElementsByClassName('flexCenter');
      for(let i =0;i<itemRow.length;i++){
        if(i%2 != 0){
          itemRow[i].classList.add("itemBG"); 
        }        
      }
    },
    updateWidth() {
      let right = 0;
      let itemBG = document.getElementsByClassName('itemBG');
      for(let i=0;i<itemBG.length;i++){
        if (window.innerWidth >= 1200) {
          right = 0 - (window.innerWidth - 1200) / 2;
          
        } else {
          right = 0 - (window.innerWidth - 1000) / 2;
        }
        itemBG[i].style.right = right+"px";
      }      
      
      window.onresize = () => {
        let right = 0;
        let itemBG = document.getElementsByClassName('itemBG');
        if (itemBG.length > 0) {
          for(let i=0;i<itemBG.length;i++){
            if (window.innerWidth >= 1200) {
              right = 0 - (window.innerWidth - 1200) / 2;
              itemBG[i].style.right = right+"px";
            }
            // else {
            //   right = 0 - (window.innerWidth - 1000) / 2;
            // }
            // itemBG[i].style.right = right+"px";
          }          
        }
      };
    },
    linkTo(item,isProduct=false){
      if(isProduct){
        window.open("/#/productDetail?id="+item.id,"_blank");
      }
      else{
        window.open("/#/productsList?category="+item.id,"_self");
      }      
    },
  },
  created() {    
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    if (isMobile) {
      this.$router.replace('/productsList');
    }
  },
  mounted(){
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    if (isMobile) return;

    this.getBaseData();
    this.$nextTick(() => {      
      this.addBGClass();
      //this.updateWidth();
    });
  }
}
</script>

<style lang="scss" src="@/assets/css/equipmentPage.scss" scoped></style>